// Geração / recuperação de device_id persistente usado para "device binding"
// (vincular funcionário ao próprio celular).
//
// Estratégia:
//   • UUID v4 estável gravado em localStorage['dp_device_id'].
//   • Se perder (clear cache / app desinstalado): gera novo → backend verá como celular diferente
//     e bloqueará login até admin resetar a senha do funcionário.

const STORAGE_KEY = "dp_device_id";

function uuidV4() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  // fallback
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = uuidV4();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return uuidV4(); // sessão privada: gera volátil
  }
}

export function getDeviceInfo() {
  const ua = (navigator.userAgent || "").slice(0, 300);
  const platform = navigator.platform || "";
  const lang = navigator.language || "";
  const screen = `${window.screen?.width || 0}x${window.screen?.height || 0}`;
  const pixelRatio = window.devicePixelRatio || 1;
  return { ua, platform, lang, screen, pixelRatio };
}

// Detecta se é dispositivo móvel real (não desktop)
export function isMobileDevice() {
  const ua = (navigator.userAgent || "").toLowerCase();
  const touchOk = navigator.maxTouchPoints > 1 || "ontouchstart" in window;
  const uaMobile = /android|iphone|ipad|ipod|blackberry|windows phone|opera mini|iemobile|mobile/i.test(ua);
  // iPad agora tem UA de Mac — detectar via touch + screen
  const likelyIpad = /macintosh/.test(ua) && navigator.maxTouchPoints > 2;
  // Screen width < 1024 + touch = provavelmente mobile
  const smallScreen = window.innerWidth < 1024 && touchOk;
  return uaMobile || likelyIpad || smallScreen;
}
